module.exports = __webpack_public_path__ + "img/ljy.f2818811.png";